import { render, staticRenderFns } from "./UrlTask.vue?vue&type=template&id=59d50299&scoped=true"
import script from "./UrlTask.vue?vue&type=script&lang=ts"
export * from "./UrlTask.vue?vue&type=script&lang=ts"
import style0 from "./UrlTask.vue?vue&type=style&index=0&id=59d50299&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d50299",
  null
  
)

export default component.exports